module.exports = __webpack_public_path__ + "static/media/Icond-5.cac17130.svg";